/* eslint-disable */
/* eslint-disable operator-linebreak */
/* eslint-disable no-unused-vars */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState, useMemo, useReducer } from 'react';

import ReactModal from 'react-modal';
import closeSvg from 'src/assets/close.svg';
import { AlertAdapter, CommonInput, OutlinedButton, RegularButton, TextAreaInput } from 'pg-ui-library';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useTranslation } from 'react-i18next';
import { maskLastFourCharacters } from 'src/utils/formatDateConvert';

import ApprovalsService, {
  BenefitReviewChangesPost,
  EmployeeReviewType,
  benefitChanges,
} from 'src/services/approvals.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  useCurrentEmployeeReviewType,
  useReviewModalIsOpen,
  useSetReviewModalIsOpen,
} from '../employee-review-changes.context';
import {
  CardGridContainer,
  CloseIcon,
  Content,
  ContentContainer,
  Footer,
  FormTitle,
  Header,
  LeftContent,
  RightContent,
  RightContentTitle,
  Row,
} from './styles';
import Card from '../card';
import { useDetailsQuery } from './queries/details.query';
import { ReviewDocumentsModal } from '../review-documents-modal';

type approvalBenefitType = benefitChanges & { approved: boolean; status?: boolean; approvalStatus?: string };

type Action =
  | { type: 'SET_INITIAL_LIST'; benefits: approvalBenefitType[] }
  | { type: 'ACCEPT_ALL' }
  | { type: 'DECLINE_ALL' }
  | { type: 'ACCEPT_ONCE'; benefitId: string }
  | { type: 'DECLINE_ONCE'; benefitId: string };

type State = approvalBenefitType[];

export const reviewReducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'SET_INITIAL_LIST':
      return action.benefits;
    case 'ACCEPT_ALL':
      return state.map(benefit =>
        !benefit.approvalStatus || benefit.approvalStatus === 'to_approve' ? { ...benefit, approved: true } : benefit
      );
    case 'DECLINE_ALL':
      return state.map(benefit =>
        !benefit.approvalStatus || benefit.approvalStatus === 'to_approve' ? { ...benefit, approved: false } : benefit
      );
    case 'ACCEPT_ONCE':
      return state.map(item =>
        item.benefitId === action.benefitId && (!item.approvalStatus || item.approvalStatus === 'to_approve')
          ? { ...item, approved: true }
          : item
      );
    case 'DECLINE_ONCE':
      return state.map(item =>
        item.benefitId === action.benefitId && (!item.approvalStatus || item.approvalStatus === 'to_approve')
          ? { ...item, approved: false }
          : item
      );
    default:
      return state;
  }
};

export const BenefitReviewModal: React.FC = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const isOpen = useReviewModalIsOpen();
  const currentEmployeeReviewSelected = useCurrentEmployeeReviewType();
  const setIsOpen = useSetReviewModalIsOpen();

  const [documentsModal, setOpenDocumentModal] = useState(false);

  const { config } = useTypedSelector(state => state.config.data);
  const companyId = config?.selectedCompanyId;

  const { data, isSuccess } = useDetailsQuery({
    eventType: (currentEmployeeReviewSelected as EmployeeReviewType).change,
    personnelNumber: (currentEmployeeReviewSelected as EmployeeReviewType).personnelNumber,
    summaryId: (currentEmployeeReviewSelected as EmployeeReviewType).summaryId,
    companyId: companyId || '',
  });

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const benefitsList = useMemo(
    () =>
      data?.benefitsChanges.map(benefit => ({
        ...benefit,
        approved: benefit.approvalStatus === 'declined' ? false : true,
      })),
    [data?.benefitsChanges]
  );

  const [reviewState, dispatchReview] = useReducer(reviewReducer, []);

  useEffect(() => {
    if (benefitsList) {
      dispatchReview({ type: 'SET_INITIAL_LIST', benefits: benefitsList });
    }
  }, [benefitsList]);

  const handleList = (benefitId: string, approved: boolean) => {
    if (approved) {
      dispatchReview({ type: 'ACCEPT_ONCE', benefitId });
    } else {
      dispatchReview({ type: 'DECLINE_ONCE', benefitId });
    }
  };

  const handleAcceptAll = () => {
    dispatchReview({ type: 'ACCEPT_ALL' });
  };

  const handleDeclineAll = () => {
    dispatchReview({ type: 'DECLINE_ALL' });
  };

  // Check if there are any pending benefits that can be approved/declined
  const hasPendingBenefits = reviewState.some(
    benefit => !benefit.approvalStatus || benefit.approvalStatus === 'to_approve'
  );

  const reviewChangesMutation = useMutation({
    mutationFn: (params: BenefitReviewChangesPost) => ApprovalsService.reviewChanges(params),
    // eslint-disable-next-line no-unused-vars
    onError: (error: Error, variables, context) => {
      AlertAdapter(error.message, 'warning');
    },
    // eslint-disable-next-line no-unused-vars
    onSuccess: (d, variables, context) => {
      AlertAdapter('Review sent successfully', 'success');
      queryClient.invalidateQueries(['approvals/pendings']);
      handleModal();
    },
  });

  const sendReview = () => {
    // Only include pending benefits in the review
    const pendingBenefits = reviewState.filter(
      benefit => !benefit.approvalStatus || benefit.approvalStatus === 'to_approve'
    );

    const postData: any = {
      id: data ? [data?.id] : '',
      approvedList: pendingBenefits.filter(b => b.approved).map(benefit => benefit.benefitId),
      declinedList: pendingBenefits.filter(b => !b.approved).map(benefit => benefit.benefitId),
      eventType: (currentEmployeeReviewSelected as EmployeeReviewType).change,
      personnelNumber: (currentEmployeeReviewSelected as EmployeeReviewType).personnelNumber,
      approve: true,
      companyId: companyId || '',
    };

    reviewChangesMutation.mutateAsync(postData);
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={handleModal}
      ariaHideApp={false}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          backgroundColor: '#F3F4F8',
          margin: 'auto',
          width: '1300px',
          height: 'max-content',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '20px',
          gap: '20px',
        },
      }}
    >
      <ReviewDocumentsModal
        isOpen={documentsModal}
        onClose={() => setOpenDocumentModal(false)}
        documents={data?.documents || []}
      />
      <Header>
        <FormTitle>{t('employeeReviewChanges.benefitReviewModal.title')}</FormTitle>
        <CloseIcon src={closeSvg} onClick={() => handleModal()} />
      </Header>
      <ContentContainer>
        <Content>
          <LeftContent>
            <Row>
              <CommonInput
                id="employeeId"
                name="employeeId"
                label="Employee ID"
                placeholder="Employee ID"
                value={data?.personnelNumber}
                onChange={() => {}}
                disabled
              />
              <CommonInput
                id="employeeName"
                name="employeeName"
                label="Employee Name"
                placeholder="Employee Name"
                value={data?.employeeName}
                onChange={() => {}}
                disabled
              />
              <CommonInput
                id="birthDate"
                name="birthDate"
                label="Birth Date"
                placeholder="Birth Date"
                value={maskLastFourCharacters(data?.birthDate)}
                onChange={() => {}}
                disabled
              />
            </Row>
            <Row>
              <CommonInput
                id="ssn"
                name="ssn"
                label="SSN"
                placeholder="SSN"
                value={data?.ssn}
                onChange={() => {}}
                disabled
              />
              <CommonInput
                id="email"
                name="email"
                label="Email"
                placeholder="Email"
                value={data?.email}
                onChange={() => {}}
                disabled
              />
              <CommonInput
                id="submissionDate"
                name="submissionDate"
                label="Submission Date"
                placeholder="Submission Date"
                value={data?.submissionDate}
                onChange={() => {}}
                disabled
              />
            </Row>
            <Row>
              <CommonInput
                id="provider"
                name="provider"
                label="Provider"
                placeholder="Provider"
                value={data?.provider}
                onChange={() => {}}
                disabled
              />

              <TextAreaInput
                label="Description"
                id="description"
                name="description"
                value={
                  data?.description
                    ? (data?.description as unknown as '')
                    : 'No description was provided by the employee.'
                }
                cols={46}
                rows={1}
                maxLength={255}
                onChange={() => {}}
                disabled
              />
            </Row>
            {data?.eventDate && (
              <Row>
                <CommonInput
                  id="eventDate"
                  name="eventDate"
                  label="QLE Event Date"
                  placeholder="Event Date"
                  value={data?.eventDate}
                  onChange={() => {}}
                  disabled
                />
              </Row>
            )}
          </LeftContent>
          <RightContent>
            <RightContentTitle>{t('employeeReviewChanges.benefitReviewModal.benefitsTitle')}</RightContentTitle>
            {hasPendingBenefits && (
              <div
                style={{
                  marginBottom: '15px',
                  padding: '10px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: '4px',
                  fontSize: '14px',
                  color: '#495057',
                }}
              >
                <strong>Review Summary:</strong>{' '}
                {reviewState.filter(b => b.approved && (!b.approvalStatus || b.approvalStatus === 'to_approve')).length}{' '}
                approved,{' '}
                {
                  reviewState.filter(b => !b.approved && (!b.approvalStatus || b.approvalStatus === 'to_approve'))
                    .length
                }{' '}
                declined
              </div>
            )}
            <CardGridContainer>
              {reviewState?.map((item, index) => (
                <Card
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  imgURL={item.imageUrl}
                  title={item.benefitName}
                  subtitle={item.date}
                  tag={item.action}
                  approved={item.approved}
                  price={item.cost}
                  alreadyApproved={!!(item.approvalStatus && item.approvalStatus !== 'to_approve')}
                  approvalStatus={item.approvalStatus}
                  onClick={(approved: boolean) => {
                    handleList(item.benefitId, approved);
                  }}
                />
              ))}
            </CardGridContainer>
          </RightContent>
        </Content>
        <Footer>
          <OutlinedButton onClick={() => setOpenDocumentModal(true)} disabled={reviewChangesMutation.isLoading}>
            {t('employeeReviewChanges.benefitReviewModal.seeDocumentsButton')}
          </OutlinedButton>
          <OutlinedButton
            style={{ marginRight: 0 }}
            onClick={() => handleAcceptAll()}
            disabled={reviewChangesMutation.isLoading || !hasPendingBenefits}
          >
            Approve All Benefits
          </OutlinedButton>

          <OutlinedButton
            style={{ marginRight: 0 }}
            onClick={() => handleDeclineAll()}
            disabled={reviewChangesMutation.isLoading || !hasPendingBenefits}
          >
            Decline All Benefits
          </OutlinedButton>

          <RegularButton
            style={{ marginRight: 0 }}
            onClick={() => sendReview()}
            disabled={reviewChangesMutation.isLoading || !hasPendingBenefits}
          >
            Submit Review
          </RegularButton>
        </Footer>
      </ContentContainer>
    </ReactModal>
  );
};
